import { useState } from 'react';
import { BoxArrowRight } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import config from '../../config';
import { logout } from '../../features/account/redux/action';
import ModalNoti from '../modalNoti';
import './index.css';


function SideBarMobile({activeIndex, onClose}) {
  const account = useSelector((state) => state.account.account);

  const dispatch = useDispatch();
  // const navigation = useNavigate();
  // const [open, setOpen] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const hidePopup = () => {
    setShowLogoutPopup(false);
  }

  const genLinkAndActiveIndex = (id) => {
    switch (id) {
      case config.menu_id.dashboard: {
        return {
          link: '/',
          activeIndex: 1
        }
      }
      case config.menu_id.user: {
        return {
          link: '/manage_user',
          activeIndex: 2
        }
      }
      case config.menu_id.storage: {
        return {
          link: '/manage_storage',
          activeIndex: 3
        }
      }
    }
  }

  return (
    <>
      <div className="nav-mobile">
        <button className="btn-close-nav-mobile"><i className="fas fa-times" onClick={onClose}></i></button>
        <div className="background-header-sidebar-mobile">
          <img src="./dashboard/bg_header_mobile.png" alt="" />
          <div className="info-user">
            <div className="avatar-info-user">
              <img src="./dashboard/Ellipse 26.png" alt="" />
            </div>
            <div className="content-info-user">
              <div className="name-info-user">{account.user.email.split('@')[0]}</div>
              <div className="mail-info-user">{account.user.email}</div>
            </div>
            <div className="logout-mobile"><BoxArrowRight size={25} onClick={() => {setShowLogoutPopup(true);}}/></div>
          </div>
        </div>
        <div className="nav-mobile-body">
          <div className="menu-link">
            {account.menu.map((item, index) => {
              const temp = genLinkAndActiveIndex(item.permission._id);
              return (
              
                <Link 
                className={activeIndex !== temp.activeIndex ? "text-decoration-none" : "active_mobile text-decoration-none"} 
                to={temp.link}
                >
                  <img className='img_dashboard' src={item.permission.icon} alt=""/> 
                  <p>{item.permission.content}</p>
                </Link>
              
              )
            })}
            {/* <Link 
              className={activeIndex !== 1 ? "text-decoration-none " : "active_mobile text-decoration-none"} 
              to='/'
            >
                <img className='img_dashboard' src={"./dashboard/space_dashboard.svg"} alt=""/> 
                <p>Dashboard</p>
            </Link> 
            <Link 
              className={activeIndex !== 2 ? "text-decoration-none" : "active_mobile text-decoration-none"} 
              to='/manage_user'
            >
                <img className='img_dashboard' src="./dashboard/account_box.png" alt=""/> 
                <p>Người dùng</p>
            </Link>
            <Link
              className={activeIndex !== 3 ? "text-decoration-none" : "active_mobile text-decoration-none"} 
              to='/manage_storage'
            >
                <img className='img_dashboard' src="./dashboard/database.png" alt=""/> 
                <p>Storage</p>
            </Link>  */}
            {/* <div
              onClick={() => {setOpen(!open)}}
              aria-expanded={open}
              className={activeIndex !==4 ? "button_collapse active_mobile p-0" : "button_collapse_active p-0"}
            >
              <img className='img_dashboard' src="./dashboard/chart.png" alt="" /> 
              <p>Người dùng</p>
            </div>
            <Collapse in={open}>
              <div className="collapse_link">
                <Link className='active_mobile' to=''>Quản lý người dùng</Link>
                <Link to=''>Báo cáo người dùng</Link>
              </div>
            </Collapse> */}
          </div>
        </div>
      </div>  
      <ModalNoti 
        show={showLogoutPopup}
        onHide={hidePopup}
        closeButton={false}
        content={'Bạn muốn thoát khỏi hệ thống?'}
        leftButton={{
          onClick: () => {
            hidePopup();
          },
          content: 'Đóng'
        }}
        rightButton={{
          onClick: () => {
            dispatch(logout());
          },
          content: 'Đồng ý'
        }}
      ></ModalNoti>
    </>
    
  );
}

export default SideBarMobile;